import { createFileRoute } from '@tanstack/react-router';
import { HealthSleepScreen } from '../../screens/health/HealthSleep';

export const Route = createFileRoute('/health/sleep')({
  component: HealthSleepScreen,
});
